import { loadObjects } from './components/objects/objects.js';
import { createCamera } from './components/camera.js';
import { createLights } from './components/lights.js';
import { createScene } from './components/scene.js';
import { createTube } from './components/meshes/knott.js';
import { Planets } from './components/Planets/Planets.js';
import { createSphere } from './components/meshes/sphere.js';

import {
  createAxesHelper,
  createGridHelper,
} from './components/helpers.js';

import { createControls } from './systems/controls.js';
import { createRenderer } from './systems/renderer.js';
import { Resizer } from './systems/Resizer.js';
import { Loop } from './systems/Loop.js';

import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { UnsignedByteType, PMREMGenerator, Vector3 } from 'three';
import  TWEEN  from 'three/examples/jsm/libs/tween.module.min'

//import  spaceWorld  from '/assets/img/space-stars.hdr?worker'


let controls;
let camera;
let renderer;
let scene;
let loop;


class World {
  constructor(container) {
    camera = createCamera();
    renderer = createRenderer();
    scene = createScene();
    loop = new Loop(camera, scene, renderer);
    container.append(renderer.domElement);
    controls = createControls(camera, renderer.domElement);
    
  
    
    const { ambientLight, mainLight } = createLights();

    //Open Space
    function setLighting(){

      new RGBELoader()
          .setDataType( UnsignedByteType )
          .load( '/assets/img/space-stars.hdr', function ( texture ) {
  
          var envMap = pmremGenerator.fromEquirectangular( texture ).texture;
  
          scene.background = envMap;
          scene.environment = envMap;
  
          texture.dispose();
          pmremGenerator.dispose();
      })
      let pmremGenerator = new PMREMGenerator( renderer );
      pmremGenerator.compileEquirectangularShader();
  
    }
    setLighting(); 

    
    //Light
    scene.add(ambientLight, mainLight);
  
    const resizer = new Resizer(container, camera, renderer);
    
    //Helpers
    scene.add(
      createAxesHelper(),
      createGridHelper(),
      );
   }

  
  async init() {
    
  //Tube
   const tube = createTube();
  //Planets
   const planets =  new Planets();
  //Human
   const { human } = await loadObjects();
  //Sphere around camera
   const sphere = createSphere();

  //Animation "human in tunnel"
    loop.updatables.push(human, camera);
    
    camera.add(sphere);
    scene.add(tube, camera);
    camera.add(human);
    

    //tunnel animation
    let percentage = 0;
    let camSpeed = 0.0002; 
  
    camera.tick = () => {

      if(percentage >= 1){
          percentage = 0;
      }
    
      percentage += camSpeed;
      let p1 = tube.geometry.parameters.path.getPointAt(percentage);
      let p2 = tube.geometry.parameters.path.getPointAt((percentage + 0.01) % 1);
      camera.position.set(p1.x, p1.y, p1.z);
      camera.lookAt(p2);
  
    }

    //Switcher

    document.getElementById("out_in_space").addEventListener("change", function() {

      if (this.value == 100) {
        setTimeout(() => {
          while (camSpeed <= 0.0012) {
            camSpeed += 0.000001;
          }
        }, 3500);
      }

      if (this.value == 100) {

          setTimeout(() => {
          scene.remove(tube);
          camera.remove(human);
          scene.add(planets);
          loop.updatables.push(planets);
          
          camera.tick = () => {};

          

          camera.position.set(0, 0, 800);
          camera.lookAt(0, 0, 0);
          
          console.log(camSpeed);


          camera.tick = () => { 
            
            

                camera.position.z -= 5;

                // if(camera.position.z <= 700) {
                // }


                
             
                
                if (camera.position.z <= 40) {
                  camera.tick = () => {};              
                  
                }

                
            }
        }, 11000);
      }
     // planets.rotation.set(0, 0, -45 * Math.PI / 180);
    //  planets.rotation.set(0, 0, 0);
      document.location.href = '#open_space';
      
     
  });

  // document.getElementById('earth').addEventListener("click", () => move('earth'));
  // document.getElementById('mars').addEventListener("click", () => move('mars'));
  // document.getElementById('moon').addEventListener("click", () => move('moon'));


//   document.getElementById("moon").addEventListener("click", function() {

//     planets.rotation.set(0, 45, 0);
//     camera.lookAt(-25, 3, -20);
//     console.log("click!");
   
// });
  




  }

  render() {
    // draw a single frame
    renderer.render(scene, camera);
  }

  start() {
    loop.start();
    TWEEN.update();
  }
  
  stop() {
    loop.stop();
  }
}

export { World };
